<p>
  terms-and-conditions works!
</p>
